import { Link } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="min-h-screen grid place-items-center bg-surface-muted px-4">
      <div className="text-center max-w-sm">
        <p className="text-7xl font-bold text-brand">404</p>
        <h1 className="mt-2 text-xl font-semibold text-text">Page introuvable</h1>
        <p className="mt-2 text-text-muted">
          L'adresse demandée n'existe pas ou a été déplacée.
        </p>
        <Link to="/planning" className="inline-block mt-4">
          <Button>Retour au planning</Button>
        </Link>
      </div>
    </div>
  )
}
